export const PLAYPAUSE = "PLAYPAUSE";
export const PLAYPAUSEPLAYLIST = "PLAYPAUSEPLAYLIST";
export const CHANGETRACK = "CHANGETRACK";
export const SEARCHTEXT = "SEARCHTEXT";

export const changePlayPause = (isPlaying) => {
  return {
    type: PLAYPAUSE,
    payload: isPlaying,
  };
};

export const changePlayPausePlayList = (isPlayListPlaying, playListId) => {
  return {
    type: PLAYPAUSEPLAYLIST,
    payload: isPlayListPlaying,
    payloadPlayListId: playListId,
  };
};
export const changeTrack = (songId) => {
  return {
    type: CHANGETRACK,
    payload: songId,
  };
};
export const searchText = (song) => {
  return {
    type: SEARCHTEXT,
    searchSong: song,
  };
};
